import { requestWrapper } from './reusable';

const config = require('../../config')();

export const copyStorePaymentOptions = (userToken, body) => requestWrapper(
  userToken,
  config.picStoresCopyResource,
  'post',
  undefined,
  body,
);

export const getStorePaymentOptions = (userToken, storeId) => requestWrapper(
  userToken,
  `${config.picStorePaymentOptionsResource}/${storeId}/payment_options`,
  'get',
);

export const saveStorePaymentOptions = (userToken, storeId, body) => requestWrapper(
  userToken,
  `${config.picStorePaymentOptionsResource}/${storeId}/payment_options`,
  'post',
  undefined,
  body,
);

export const getCountryPaymentOptions = (userToken, countryCode) => requestWrapper(
  userToken,
  config.picPaymentOptionsResource,
  'get',
  { countryCode },
);
